import { useMutation } from "@apollo/react-hooks";
import { ChoiceList, Modal, Stack } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import { UPDATE_ORDER_PRINTING_METHOD } from "../../../graphql/mutations";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { MERCHIZE_PRINTING_METHODS } from "../../../variable";
import { useToastContext } from "../../shared/ToastContext";

const MERCHIZE_PRINTING_METHOD_OPTIONS = Object.entries(
    MERCHIZE_PRINTING_METHODS,
).map(([value, label]) => ({ value, label }));
MERCHIZE_PRINTING_METHOD_OPTIONS.unshift({ value: "", label: "Default" });

export default function UpdatePrintingMethod({
    open,
    onClose,
    ids,
    value,
    refetch,
}) {
    const [state, setState] = useState([""]);

    const [setDelay] = useTimeout();
    const { setNotify, toggleToast } = useToastContext();
    const [updatePrintingMethod, { loading }] = useMutation(
        UPDATE_ORDER_PRINTING_METHOD,
        {
            onCompleted: () => {
                setNotify({ msg: "Update Printing method succes", err: false });
                onClose && onClose();

                setDelay(() => {
                    refetch && refetch();
                }, 1500);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    React.useEffect(() => {
        if (value?.printingMethod) {
            if (
                Object.values(MERCHIZE_PRINTING_METHODS).includes(
                    value.printingMethod,
                )
            ) {
                setState([value.printingMethod]);
            }
        }
    }, [value]);

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });


        updatePrintingMethod({
            variables: {
                ids,
                printingMethod: state?.length > 0 ? state[0] : "",
            },
        });
    }, [state, ids, updatePrintingMethod, setNotify, toggleToast]);

    const handleStateChange = useCallback((state) => {
        setState(state);
    }, []);

    return (
        <Modal
            title="Update Printing Method"
            sectioned
            open={open}
            onClose={onClose}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <Stack vertical>
                <ChoiceList
                    title="Printing methods"
                    selected={state}
                    onChange={handleStateChange}
                    choices={MERCHIZE_PRINTING_METHOD_OPTIONS}
                />
            </Stack>
        </Modal>
    );
}
